import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Box,
  Text,
  VStack,
  Button,
  Input,
  useToast,
  Select,
  InputGroup,
  InputLeftElement,
  IconButton,
  Image,
  Spinner,
  FormControl,
  FormLabel,
} from '@chakra-ui/react';
import '../../styles/portalys/portalys.css';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../../modules/layout/layout';
import { getResellEventsBySlug } from '../../utils/actions/event';
import { isEmpty } from 'lodash';
import moment from 'moment';
import 'moment/min/locales';
import { useRecoilState } from 'recoil';
import { ticket } from '../../recoil/atoms/tickets';
import { user } from '../../recoil/atoms/user';
import { useMediaQuery } from '../../utils/useMediaQuery';
import axios from '../../utils/api/axios';
import { useLocation } from 'react-router-dom';
import './event-components/eventDetails.css';
import { useCookies } from 'react-cookie';
import { getCode } from 'iso-3166-1-alpha-2';
import {
  RegistraionModalTypes,
  registration,
} from '../../recoil/atoms/registration';
import {
  BuyModal,
  UploadProofModal,
  ViewProofModal,
  SellerInfoModal,
} from './event-components/modals';
import {
  GetYourResellTicketsButton,
  BuySellTicketsButton,
} from './event-components/eventButtons';
import { EventImageComponent } from './event-components/eventInfo';
import { PageNotFound } from './event-components/pageNotFound';
import { EventInfoComponent } from './event-components/eventInfo';
import {
  DecriptionComponent,
  LineupComponent,
  SpotifyComponent,
} from './event-components/eventSections';
import { TagsComponent } from './event-components/tags';
import { MapComponent } from './event-components/mapComponent';

import { SecondaryMarketFooter } from '../../modules/pages/SecondaryMarket/text';
import {
  ResellTabs,
  PlaceBidSection,
  SellerComponent,
  BuyerComponent,
} from './event-components/resellSection';
import { theme } from '../../styles/theme/base';
import { fetchUserData } from '../../utils/actions/registration';
import { ResellFeesComponentsMobile } from './event-components/total';
import MarkImage from '../../static/assets/images/sell.jpg';
import { DeleteIcon } from '@chakra-ui/icons';
import uploadIcon from '../../static/assets/images/uploadIcon.svg';
import logo from '../../static/assets/images/portalysLogo.svg';
import { DownloadAppComponent } from '../appPromo/downloadApp';

// Add these styles at the top of your component
const searchStyles = {
  searchContainer: {
    width: '100%',
    height: '100%',
    marginTop: '10px',
  },
  searchBarWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '5px',
    margin: '15px',
    padding: '5px',
    borderRadius: '100px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  searchButton: {
    padding: '12px',
    margin: '5px',
    borderRadius: '100px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    cursor: 'pointer',
  },
  searchInput: {
    flex: 1,
    border: 'none',
    backgroundColor: 'transparent',
    color: 'white',
    fontSize: '20px',
    lineHeight: '24px',
    height: '28px',
    fontFamily: 'Inter, sans-serif',
    outline: 'none',
    padding: '0 10px',
  },
  dismissButton: {
    borderRadius: '100px',
    padding: '10px',
    margin: '4px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    cursor: 'pointer',
  },
};

export default function ResellEvent(props) {
  const [_R, setRegistrationModal] = useRecoilState(registration);
  const toast = useToast();
  const navigate = useNavigate();
  const params = useParams();
  const { id } = params;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [event, setEvent] = useState();
  const [_, setTicket] = useRecoilState(ticket);
  const [_U, setUser] = useRecoilState(user);
  const isTablet = useMediaQuery('(max-width: 991px)');
  const isMobile = useMediaQuery('(max-width: 760px)');
  const [password, setPassword] = useState('');
  const [cookies, setCookie] = useCookies([`${event?.eventName}-password`]);
  const [openSite, setOpenSite] = useState(true);
  const [error, setError] = useState(false);
  const [pageNotFound, setPageNotFound] = useState(false);
  const [language, setLanguage] = useState(null);
  const is24HourFormat = moment.locale() !== 'en';
  const TimeFormat = is24HourFormat ? 'HH:mm' : 'h:mm A';
  const [selectedTab, setSelectedTab] = useState('tickets');
  const [buyModalOpen, setBuyModalOpen] = useState(false);
  const [uploadProofModalOpen, setUploadProofModalOpen] = useState(false);
  const [viewProofModalOpen, setViewProofModalOpen] = useState(false);
  const [sellerInfoModalOpen, setSellerInfoModalOpen] = useState(false);
  const [offering, setOffering] = useState(false);
  const [selling, setSelling] = useState(false);
  const [text1, setText1] = useState('');
  const [text2, setText2] = useState('');
  const [price, setPrice] = useState('100');
  const [quantity, setQuantity] = useState(1);
  const [selectedTicketType, setSelectedTicketType] = useState('');
  const [expiration, setExpiration] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [images, setImages] = useState([]);
  const [profilePicture, setProfilePicture] = useState('');
  const [proofUrl, setProofUrl] = useState([]);
  const [selectedListing, setSelectedListing] = useState([]);
  const [selectedListings, setSelectedListings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [buyerFee, setBuyerFee] = useState(0);
  const [successMessage, setSuccessMessage] = useState('');
  const bgColor = '#000';
  const accentColor = '#fff';
  const [directLink, setDirectLink] = useState(false);
  const [results, setResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [isEventLoading, setIsEventLoading] = useState(false);
  const isCreateListingButtonDisabled =
    !price || images.length === 0 || !quantity || !selectedTicketType;
  const sellerFee = Number(
    (price * quantity * event?.fee_percentage) / 100 +
      event?.fee_fixed * quantity
  ).toFixed(2);
  const total = Number(price * quantity - sellerFee).toFixed(2);
  const [eventName, setEventName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const init = async () => {
    if (id) {
      setIsEventLoading(true);
      try {
        const val = await getResellEventsBySlug(id);
        if (!isEmpty(val)) {
          setEvent(val);
          const ticketTypesJson = val?.ticketTypes
            ? JSON.parse(val.ticketTypes)
            : [];
          setSelectedTicketType(ticketTypesJson[0] || '');
        }
        if (val.error) {
          setPageNotFound(true);
        }
      } catch (error) {
        setPageNotFound(true);
        console.error(error);
      } finally {
        setIsEventLoading(false);
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    init();
  }, [id]);

  useEffect(() => {
    setProfilePicture(_U.userData?.image || '');
    setEmail(_U.userData?.email || '');
    setFirstName(_U?.userData?.firstName || '');
    setLastName(_U.userData?.lastName || '');
  }, [_U]);

  useEffect(() => {
    // Clear event and results when navigating to /sell
    if (location.pathname === '/sell') {
      setEvent(undefined);
      setResults([]);
    }
  }, [location.pathname]);

  const updateUser = async () => {
    const token = _U?.token;
    const capitalizedFirstName =
      firstName.charAt(0).toUpperCase() + firstName.slice(1);
    const capitalizedLastName =
      lastName.charAt(0).toUpperCase() + lastName.slice(1);

    await axios
      .put(
        '/api/',
        {
          firstName: capitalizedFirstName,
          lastName: capitalizedLastName,
          email,
          image: profilePicture,
        },
        {
          headers: {
            'x-auth-token': 'Bearer ' + token,
          },
        }
      )
      .catch((err) => {
        toast({
          title: 'Data Updating Error',
          status: 'error',
          isClosable: true,
          duration: 4000,
          position: 'top-right',
        });
      });
  };
  const getUser = async () => {
    const token = _U?.token;
    if (token) {
      await fetchUserData(token)
        .then((user) => {
          setUser((lp) => {
            return {
              ...lp,
              token,
              userData: user?.user,
            };
          });
        })
        .catch((err) => {});
    }
  };

  const createListing = async () => {
    const token = _U?.token;

    const body = {
      uuid: event.uuid,
      sellerId: _U.userData.userId,
      price: price,
      images: images,
      quantity: quantity,
      type: selectedTicketType,
      offerId: null,
      isWeb: true,
    };
    await axios
      .post('/api/createListing', body, {
        headers: {
          'x-auth-token': 'Bearer ' + token,
        },
      })
      .then((r) => {
        init();
        setSuccessMessage(r?.data?.message);
        window.location.href = '/listing-success';
      })
      .catch((err) => {
        toast({
          title: 'Listing Creation Error',
          status: 'error',
          isClosable: true,
          duration: 4000,
          position: 'top-right',
        });
      });
  };

  const handleSellerModal = () => {
    if (isEmpty(_U?.userData)) {
      setRegistrationModal((lp) => {
        return {
          ...lp,
          openModal: true,
          modalType: RegistraionModalTypes.SIGNUP,
        };
      });
      return;
    }
    setSellerInfoModalOpen(true);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    await updateUser();
    await getUser();
    await createListing();
    setSellerInfoModalOpen(false);
    setBuyModalOpen(false);
    setIsLoading(false);
  };

  const handleSearchEvents = async (query) => {
    try {
      if (!query.trim()) {
        setResults([]);
        setHasSearched(false);
        return;
      }

      setHasSearched(true);
      const response = await axios.post('/api/search', {
        query,
      });
      setResults(response.data.results);
    } catch (error) {
      console.error('Error searching for events:', error);
      toast({
        title: 'Error searching events',
        status: 'error',
        isClosable: true,
        duration: 4000,
        position: 'top-right',
      });
    }
  };
  const [dragging, setDragging] = useState(false);
  const [loading, setLoading] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const dropRef = useRef(null);
  const [errorFields, setErrorFields] = useState();

  const handleRequestEvent = async () => {
    if (!eventName.trim()) return;

    setIsSubmitting(true);
    try {
      const body = {
        eventName,
        userId: _U?.userData?.userId,
      };
      await axios.post('/api/request-event', body);

      toast({
        title: 'Event requested! Check again in a couple of hours',
        status: 'success',
        duration: 1500,
        isClosable: true,
        position: 'top-right',
      });
      setEventName('');
    } catch (error) {
      console.error(error);
      toast({
        title: 'Failed to request event',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-right',
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleDragEnter = (e) => {
    e.preventDefault();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files) {
      Array.from(e.dataTransfer.files).forEach((file) => {
        uploadPurchaseImage(file);
      });
    }
  };

  const handleMouseDown = (e) => {
    setDragging(true);
    const initialX = e.clientX - position.x;
    const initialY = e.clientY - position.y;

    const handleMouseMove = (e) => {
      setPosition({
        x: e.clientX - initialX,
        y: e.clientY - initialY,
      });
    };

    document.addEventListener('mousemove', handleMouseMove);

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      setDragging(false);
    };

    document.addEventListener('mouseup', handleMouseUp);
  };

  const uploadPurchaseImage = async (image) => {
    const fd = new FormData();
    fd.append('image', image);
    fd.append('type', 'event');
    setLoading(true);
    await axios
      .post('/api/uploadImage', fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        if (res.data.status) {
          if (res.data.link) {
            setImages((prevImages) => [...prevImages, res.data.link]);
          }
        } else {
          toast({
            title: 'Cover Uploading Error',
            status: 'error',
            isClosable: true,
            duration: 4000,
            position: 'top-right',
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast({
          title: 'Cover Uploading Error',
          status: 'error',
          isClosable: true,
          duration: 4000,
          position: 'top-right',
        });
      });
  };
  const handleDeleteImage = (indexToDelete) => {
    setImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToDelete)
    );
  };
  const handleFileSelect = (e) => {
    const files = e.target.files;
    if (files) {
      Array.from(files).forEach((file) => uploadPurchaseImage(file));
    }
  };

  const TicketDetails = (
    <div>
      {event ? (
        <EventInfoComponent
          eventName={event?.eventName}
          accentColor={accentColor}
          startTime={event?.startTime}
          endTime={event?.endTime}
          startDate={event?.startDate}
          city={event?.city}
          location={event?.location}
          totalTickets={event?.totalTickets}
          available={event?.available}
          hideLikes={true}
          seePerks={event?.seePerks}
          sawPerks={event?.sawPerks}
          isMobile={isMobile}
          moment={moment}
          TimeFormat={TimeFormat}
        />
      ) : (
        <Box sx={searchStyles.searchContainer}>
          <Box
            sx={{
              ...searchStyles.searchBarWrapper,
              margin: isMobile ? '15px 0px' : '15px',
            }}
          >
            <Box sx={searchStyles.searchButton}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box>
            <Input
              placeholder="Search for events..."
              sx={searchStyles.searchInput}
              onChange={(e) => handleSearchEvents(e.target.value)}
              _placeholder={{ color: 'rgba(255, 255, 255, 0.5)' }}
              variant="unstyled"
            />
            {results.length > 0 && (
              <Box
                sx={searchStyles.dismissButton}
                onClick={() => {
                  setResults([]);
                  // Clear the input - you'll need to add a ref to the input or manage its value in state
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M18 6L6 18M6 6L18 18"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Box>
            )}
          </Box>

          {/* Results section */}
          <VStack spacing={4} px={isMobile ? '0px' : '15px'}>
            {isLoading ? (
              <Text color="white">Loading...</Text>
            ) : results.length > 0 ? (
              results
                ?.map((item) => {
                  if (item.type === 'resellEvent') {
                    return (
                      <Box
                        key={item.uuid}
                        p={4}
                        bg={item.bgColor || 'rgba(255,255,255,0.1)'}
                        borderRadius="md"
                        cursor="pointer"
                        onClick={() => navigate(`/sell/${item.slug}`)}
                        display="flex"
                        flexDirection="row"
                        gap={4}
                        width="100%"
                      >
                        <Box
                          width="60px"
                          height="60px"
                          overflow="hidden"
                          borderRadius="md"
                        >
                          <img
                            src={item.eventImage}
                            alt={item.eventName}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        </Box>
                        <Box>
                          <Text
                            color={item.accentColor || 'white'}
                            fontWeight="bold"
                            mb={1}
                          >
                            {item.eventName}
                          </Text>
                          <Text
                            color={item.accentColor || 'white'}
                            fontSize="sm"
                          >
                            {moment(item.startDate).format('ddd, D MMM')}{' '}
                            {moment(item.startTime, 'h:mm A').format('HH:mm')}h
                          </Text>
                          <Text
                            color={item.accentColor || 'white'}
                            fontSize="sm"
                          >
                            {item.city}
                            {item.city && item.country && ', '}
                            {item.country?.replace('United States', 'US')}
                          </Text>
                        </Box>
                      </Box>
                    );
                  }
                  return null;
                })
                .filter(Boolean)
            ) : hasSearched ? (
              <Box
                p={6}
                bg="rgba(255,255,255,0.1)"
                borderRadius="20px"
                width="100%"
                border="1px solid rgba(255,255,255,0.12)"
              >
                <VStack spacing={4} align="stretch">
                  <Text color="white" fontSize="lg" fontWeight="bold">
                    Not finding the event you're looking for? Request it here:
                  </Text>
                  <FormControl>
                    <FormLabel color="white">Event name</FormLabel>
                    <Input
                      placeholder="Solomun 1 March NY"
                      bg="rgba(255,255,255,0.08)"
                      border="1px solid rgba(255,255,255,0.12)"
                      color="white"
                      _placeholder={{ color: 'rgba(255,255,255,0.5)' }}
                      value={eventName}
                      onChange={(e) => setEventName(e.target.value)}
                    />
                  </FormControl>
                  <Button
                    fontWeight="700"
                    textAlign="center"
                    margin={isMobile ? '0 20px' : '20px 0'}
                    fontSize="1rem"
                    borderRadius="40px"
                    outline="none"
                    sx={theme.buttons.primary.shape}
                    bg={theme.buttons.primary.default}
                    color={theme.buttons.primary.color}
                    className="inter-700"
                    css={{
                      width: '100%',
                    }}
                    _hover={{
                      bg: !eventName && theme.buttons.primary.hover,
                      boxShadow:
                        !eventName && theme.buttons.primary.hoverBoxShadow,
                      cursor: !eventName ? 'pointer' : 'default',
                    }}
                    _active={{
                      boxShadow:
                        !eventName && theme.buttons.primary.activeBoxShadow,
                    }}
                    _disabled={{
                      bg: theme.buttons.primary.disabled,
                      color: theme.buttons.primary.colorDisabled,
                    }}
                    isDisabled={!eventName} // Add the isDisabled prop here
                    isLoading={isSubmitting}
                    onClick={handleRequestEvent}
                  >
                    Request Event
                  </Button>
                </VStack>
              </Box>
            ) : null}
          </VStack>
        </Box>
      )}
    </div>
  );

  const ListForm = (
    <div>
      {event?.isOver ? (
        <Box marginTop="50px">
          <Text>This event has ended.</Text>
        </Box>
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          gap="24px"
          width="100%"
          marginTop="50px"
        >
          <Box width="100%">
            <DownloadAppComponent isTablet={isTablet} isMobile={isMobile} />
          </Box>

          <Text
            color="#FFF"
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="600"
            textAlign="start"
            marginBottom="8px"
          >
            Let's list your tickets!
          </Text>

          {/* Bank connection banner */}
          <Box
            display="flex"
            width="100%"
            padding="16px 24px"
            alignItems="center"
            gap="4px"
            borderRadius="16px"
            background="#001A0D"
            marginBottom="16px"
          >
            <Text
              flex="1 0 0"
              color="#A3FFD2"
              fontFamily="Inter"
              fontSize="16px"
              fontStyle="normal"
              fontWeight="600"
              lineHeight="148%"
              letterSpacing="-0.08px"
            >
              Sell without fees and get paid out instantly! 💸
            </Text>
          </Box>

          {/* Ticket Type Select */}
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            flex="1 0 0"
            gap="8px"
          >
            <Text
              color="#FFF"
              fontFamily="Inter"
              fontSize="14px"
              fontStyle="normal"
              fontWeight="400"
              lineHeight="120%"
              paddingLeft="16px"
            >
              Ticket Type
            </Text>
            <Select
              display="flex"
              height="56px"
              justifyContent="space-between"
              alignItems="center"
              alignSelf="stretch"
              borderRadius="10px"
              border="1px solid rgba(255, 255, 255, 0.12)"
              background="rgba(255, 255, 255, 0.08)"
              lineHeight="19.2px"
              onChange={(e) => setSelectedTicketType(e.target.value)}
              value={selectedTicketType}
              isDisabled={directLink}
            >
              {event?.ticketTypes
                .replace(/[\[\]"]+/g, '')
                .split(',')
                .map((type, index) => (
                  <option key={index} value={type.trim()}>
                    {type.trim()}
                  </option>
                ))}
            </Select>
          </Box>

          {/* Quantity Select */}
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            gap="8px"
            flex="1 0 0"
          >
            <Text
              color="#FFF"
              fontFamily="Inter"
              fontSize="14px"
              fontStyle="normal"
              fontWeight="400"
              lineHeight="120%"
              paddingLeft="16px"
            >
              Quantity
            </Text>
            <Select
              display="flex"
              height="56px"
              justifyContent="space-between"
              alignItems="center"
              alignSelf="stretch"
              borderRadius="10px"
              border="1px solid rgba(255, 255, 255, 0.12)"
              background="rgba(255, 255, 255, 0.08)"
              lineHeight="19.2px"
              onChange={(e) => setQuantity(e.target.value)}
              value={quantity}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
            </Select>
          </Box>

          {/* Price Input */}
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            gap="8px"
            flex="1 0 0"
          >
            <Text
              color="#FFF"
              fontFamily="Inter"
              fontSize="14px"
              fontStyle="normal"
              fontWeight="400"
              lineHeight="120%"
              paddingLeft="16px"
            >
              Price Per Ticket
            </Text>
            <Box
              display="flex"
              height="56px"
              alignItems="center"
              borderRadius="10px"
              border="1px solid rgba(255, 255, 255, 0.20)"
              background="rgba(255, 255, 255, 0.05)"
            >
              <InputGroup>
                <InputLeftElement
                  pointerEvents="none"
                  color="rgba(255, 255, 255, 255)"
                  fontSize="16px"
                  children="$"
                  disabled={!offering && !selling}
                />
                <Input
                  color="rgba(255, 255, 255, 255)"
                  fontSize="16px"
                  className="inter-400"
                  fontStyle="normal"
                  fontWeight="400"
                  lineHeight="132%"
                  display="flex"
                  background="transparent"
                  paddingLeft="24px"
                  border="none"
                  _focus={{
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none',
                  }}
                  pl="28px"
                  type="number"
                  onChange={(e) => setPrice(e.target.value)}
                  value={price}
                />
              </InputGroup>
            </Box>
          </Box>

          {/* Upload Proof Component */}
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            gap="8px"
            flex="1 0 0"
          >
            <Text
              color="#FFF"
              fontFamily="Inter"
              fontSize="14px"
              fontStyle="normal"
              fontWeight="400"
              lineHeight="120%"
              paddingLeft="16px"
            >
              Upload proof of purchase
            </Text>
            <Box
              display="flex"
              padding="40px 0px"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              gap="4px"
              alignSelf="stretch"
              borderRadius="24px"
              border="1px dashed rgba(255, 255, 255, 0.40)"
              onClick={() => {
                if (!loading) {
                  const input = document.createElement('input');
                  input.type = 'file';
                  input.accept = 'image/*';
                  input.multiple = true; // Allow multiple files
                  input.onchange = handleFileSelect;
                  input.click();
                }
              }}
              _hover={{
                background: !loading ? 'rgba(255, 255, 255, 0.08)' : 'none',
                cursor: !loading ? 'pointer' : 'default',
              }}
            >
              {loading ? (
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  gap="16px"
                >
                  <Spinner size="xl" color="white" />
                  <Text
                    color="rgba(255, 255, 255, 0.80)"
                    textAlign="center"
                    fontFamily="Inter"
                    fontSize="16px"
                    fontStyle="normal"
                    fontWeight="500"
                    lineHeight="132%"
                  >
                    Uploading...
                  </Text>
                </Box>
              ) : images.length > 0 ? (
                <Box display="flex" gap="10px" flexWrap="wrap">
                  {images.map((img, index) => (
                    <Box
                      key={index}
                      position="relative"
                      display="inline-block"
                      margin="8px"
                    >
                      <IconButton
                        icon={<DeleteIcon />}
                        aria-label="Delete image"
                        position="absolute"
                        color="red"
                        top={2}
                        right={2}
                        zIndex={1}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteImage(index);
                        }}
                        size="lg"
                      />
                      <Image
                        src={img}
                        width="200px"
                        height="auto"
                        borderRadius="12px"
                      />
                    </Box>
                  ))}
                </Box>
              ) : (
                <Box
                  display="flex"
                  width="225px"
                  flexDirection="column"
                  alignItems="center"
                  gap="16px"
                >
                  <Box
                    display="flex"
                    width="179px"
                    flexDirection="column"
                    alignItems="center"
                    gap="12px"
                  >
                    <Image src={uploadIcon} width="40px" height="40px" />
                    <Text
                      color="rgba(255, 255, 255, 0.80)"
                      textAlign="center"
                      fontFamily="Inter"
                      fontSize="16px"
                      fontStyle="normal"
                      fontWeight="500"
                      lineHeight="132%"
                    >
                      Browse files to upload proof
                    </Text>
                  </Box>
                  <Text
                    color="#FF5C5C"
                    textAlign="center"
                    fontFamily="Inter"
                    fontSize="16px"
                    fontStyle="normal"
                    fontWeight="500"
                    lineHeight="132%"
                  >
                    Do not upload the QR Code
                  </Text>
                </Box>
              )}
            </Box>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            alignSelf="stretch"
          >
            <Box display="flex" alignItems="center" gap="16px">
              <Box
                display="flex"
                width="44px"
                height="44px"
                justifyContent="center"
                alignItems="center"
              >
                <Image src={logo} alt="User Icon" width="44px" height="44px" />
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                gap="2px"
              >
                <Box display="flex" alignItems="center" gap="8px">
                  <Text
                    color="#FFF"
                    fontFamily="Gordita"
                    fontSize="16px"
                    fontStyle="normal"
                    fontWeight="700"
                    lineHeight="132%"
                  >
                    Service Fee
                  </Text>
                </Box>
              </Box>
            </Box>
            <Text
              color="rgba(255, 255, 255, 0.80)"
              textAlign="center"
              fontFamily="Gordita"
              fontSize="16px"
              fontStyle="normal"
              fontWeight="400"
              lineHeight="24px"
            >
              ${sellerFee}
            </Text>
          </Box>

          {/* Create Listing Button */}
          <Box
            display="flex"
            justifyContent="center"
            width="100%"
            paddingTop="0px"
          >
            <Button
              fontWeight="700"
              textAlign="center"
              margin={isMobile ? '0 20px' : '20px 0'}
              fontSize="1rem"
              borderRadius="40px"
              outline="none"
              sx={theme.buttons.primary.shape}
              bg={theme.buttons.primary.default}
              color={theme.buttons.primary.color}
              className="inter-700"
              css={{
                width: '100%',
              }}
              _hover={{
                bg:
                  !isCreateListingButtonDisabled && theme.buttons.primary.hover,
                boxShadow:
                  !isCreateListingButtonDisabled &&
                  theme.buttons.primary.hoverBoxShadow,
                cursor: !isCreateListingButtonDisabled ? 'pointer' : 'default',
              }}
              _active={{
                boxShadow:
                  !isCreateListingButtonDisabled &&
                  theme.buttons.primary.activeBoxShadow,
              }}
              _disabled={{
                bg: theme.buttons.primary.disabled,
                color: theme.buttons.primary.colorDisabled,
              }}
              onClick={handleSellerModal}
              isDisabled={isCreateListingButtonDisabled} // Add the isDisabled prop here
            >
              Create Listing{quantity > 1 ? `s` : ''}
            </Button>
          </Box>
        </Box>
      )}
    </div>
  );

  return (
    <Box bg={bgColor} minHeight="100vh">
      <Layout {...props} bgColor={bgColor}>
        <div>
          <div>
            <SellerInfoModal
              isOpen={sellerInfoModalOpen}
              onClose={() => setSellerInfoModalOpen(false)}
              isMobile={isMobile}
              firstName={firstName}
              setFirstName={setFirstName}
              lastName={lastName}
              setLastName={setLastName}
              email={email}
              setEmail={setEmail}
              profilePicture={profilePicture}
              setProfilePicture={setProfilePicture}
              total={total}
              handleSubmit={handleSubmit}
              isLoading={isLoading}
              directLink={directLink}
            />
            {isEventLoading ? (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="90vh"
                color="white"
              >
                <Spinner size="xl" mb={4} />
                <Text fontSize="2rem" fontWeight="700">
                  Loading...
                </Text>
              </Box>
            ) : (
              <Box className={'event-details-wrapper'}>
                <Box className={'event-left-components'}>
                  <Box
                    display="flex"
                    width="100%"
                    flexDirection="column"
                    alignItems="flex-start"
                    gap="28px"
                    marginBottom={!isMobile ? '200px' : '0px'}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="flex-start"
                      gap="24px"
                      alignSelf="stretch"
                    >
                      {isMobile && event ? (
                        <></>
                      ) : (
                        <EventImageComponent
                          extraPictures={event?.extraPictures}
                          isTablet={isTablet}
                          eventImage={event?.eventImage || MarkImage}
                        />
                      )}
                    </Box>
                  </Box>

                  {(isMobile || isTablet) && (
                    <>
                      <Box margin={'1.88rem 0'}>
                        {event ? (
                          <Box
                            p={4}
                            bg={event.bgColor || 'rgba(255,255,255,0.1)'}
                            borderRadius="md"
                            display="flex"
                            flexDirection="row"
                            gap={4}
                            width="100%"
                            mb={4}
                          >
                            <Box
                              width="60px"
                              height="60px"
                              overflow="hidden"
                              borderRadius="md"
                            >
                              <img
                                src={event.eventImage || MarkImage}
                                alt={event.eventName}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            </Box>
                            <Box>
                              <Text
                                color={event.accentColor || 'white'}
                                fontWeight="bold"
                                mb={1}
                              >
                                {event.eventName}
                              </Text>
                              <Text
                                color={event.accentColor || 'white'}
                                fontSize="sm"
                              >
                                {moment(event.startDate).format('ddd, D MMM')}{' '}
                                {moment(event.startTime, 'h:mm A').format(
                                  TimeFormat
                                )}
                              </Text>
                              <Text
                                color={event.accentColor || 'white'}
                                fontSize="sm"
                              >
                                {event.city}
                                {event.city && event.country && ', '}
                                {event.country?.replace('United States', 'US')}
                              </Text>
                            </Box>
                          </Box>
                        ) : (
                          TicketDetails
                        )}

                        {id && ListForm}
                      </Box>
                    </>
                  )}
                </Box>

                <Box className={'event-separator'} />

                {!isMobile && !isTablet && (
                  <Box
                    marginBottom="100px"
                    className={'event-right-components'}
                  >
                    {TicketDetails}
                    {id && ListForm}
                  </Box>
                )}
              </Box>
            )}
          </div>
        </div>
      </Layout>
    </Box>
  );
}
